import { vservice } from '@niknevis/vue-modules'
import {
  ContentItemSaveContentRequestModelInAdmin,
  ContentItemSendToCompletedRequestModel,
  ContentItemSendToQueueRequestModel,
  ContentItemSendToReviewRequestModel,
  ManualDiscountRequestModel
} from '@/modules/content-item/models/content-item-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { AdminContentItemRoutes } from '@/modules/content-item/routes/admin-content-item.route'
import {
  ContentItemGetDataForCompleteResourceModel,
  ContentItemStatus,
  ContentItemUpdatableAttributesResourceModel,
  ContentItemUpdatableAttributesResourceTypeInAdmin
} from '@/modules/content-item/models/content-item-resource.model'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'
import { Data } from '@/modules/shared/models/data'

@vservice()
export class AdminContentItemService {
  constructor(
    private readonly routes: AdminContentItemRoutes
  ) {
  }

  updateContentItemManualDiscount(id: number, data: ManualDiscountRequestModel) {
    return Inertia.put(
      this.routes.updateItemManualDiscount(id),
      data.manual_discount ? data : { manual_discount: null }
    )
  }

  sendToQueue(id: number, data: ContentItemSendToQueueRequestModel): any {
    return Inertia.put(
      this.routes.sendToQueue(id),
      data
    )
  }

  changeProfit(contentItemId: number, data: ProfitRequest) {
    return Inertia.post(
      this.routes.changeProfit(contentItemId),
      data
    )
  }

  getUpdatableAttributes(contentItemId): Promise<ContentItemUpdatableAttributesResourceTypeInAdmin> {
    return HTTP.get(
      this.routes.getUpdatableAttributes(contentItemId)
    ).then(result => result.json())
  }

  update(contentItemId: number, data: ContentItemUpdatableAttributesResourceModel) {
    return Inertia.put(
      this.routes.update(contentItemId),
      data
    )
  }

  sendToReview(contentItemId: number, data: Omit<ContentItemSendToReviewRequestModel, 'status'>) {
    data['status'] = ContentItemStatus.REVIEW
    return Inertia.put(
      this.routes.sendToReview(contentItemId),
      data
    )
  }

  sendToCompleted(contentItemId: number, data: Omit<ContentItemSendToCompletedRequestModel, 'status'>) {
    data['status'] = ContentItemStatus.COMPLETED
    return Inertia.put(
      this.routes.sendToCompleted(contentItemId),
      data
    )
  }

  getDataForComplete(contentItemId: number): Promise<Data<ContentItemGetDataForCompleteResourceModel>> {
    return HTTP.get(
      this.routes.getDataForComplete(contentItemId)
    ).then(result => result.json())
  }

  saveContent(contentItemId: number, data: ContentItemSaveContentRequestModelInAdmin) {
    return Inertia.put(
      this.routes.saveContent(contentItemId),
      data
    )
  }
}
